export default "__VITE_PUBLIC_ASSET__742210cf__"